var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeau02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.1 23.1",
    style: {
      enableBackground: "new 0 0 35.1 23.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EEEDEE;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#AE1C28;}\r\n\t.st3{fill:#002395;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#AE1C28;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#004288;}\r\n\t.st7{fill:#21468B;}\r\n\t.st8{fill:#FFFFFF;}\r\n\t.st9{fill:#DD0000;}\r\n\t.st10{fill:#FFCE00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0,7.7h7.8L0,2.6V1.7l9.1,6h2.6L0,0l0,0h3.9l10.7,7V0h1.2v9.2H0V7.7L0,7.7z M20.5,0v7l10.7-7h1.3L20.8,7.7h2.6 L35.1,0v2.6l-7.8,5.1h7.8v1.5H19.3V0L20.5,0L20.5,0z M35,15.4h-7.8l7.8,5.1v0.9l-9.1-6h-2.6L35,23.1l0,0h-3.9l-10.7-7v7h-1.2v-9.2 H35V15.4L35,15.4z M14.6,23v-7L3.9,23H2.7l11.7-7.7h-2.7L0,23v-2.6l7.8-5.1H0v-1.5h15.7V23L14.6,23L14.6,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M14.3,15.4L2.7,23H0l11.7-7.6H14.3L14.3,15.4z M19.3,0v9.2h15.8v4.6H19.3V23h-3.5v-9.2H0V9.2h15.7V0L19.3,0 L19.3,0z M0,1.7l9.1,6h2.6L0,0V1.7L0,1.7z M35,0L23.3,7.7h-2.6L32.4,0L35,0L35,0z M23.4,15.4l11.7,7.7v-1.7l-9.1-6H23.4L23.4,15.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35,15.4v5.1l-7.8-5.1L35,15.4L35,15.4z M4,0h10.7v7L4,0L4,0z M0,20.5v-5.1h7.8L0,20.5L0,20.5z M0,7.7V2.6 l7.8,5.1H0L0,7.7z M14.6,23H4l10.7-7v7H14.6z M31.1,23H20.5v-7L31.1,23L31.1,23z M20.5,0h10.7L20.5,7V0L20.5,0z M35,2.6v5.1h-7.8 L35,2.6L35,2.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeau02);
export default __webpack_public_path__ + "static/media/Drapeau02.e56e9bdd9d663d1a077486e6906bd646.svg";
export { ForwardRef as ReactComponent };